import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../myfin_v2/css/common.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import GroupingDrilldownTable from "./GroupingDrilldownTable"


const PNLStatement = (props) => {
  const { plData, selectedL1, selectedL2 } = props;



  return (
    <>
      {1 === true ? (
        <div
          className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }}
        >
          <Spinner animation="grow" size="sm" />
          <Spinner animation="grow" style={{ margin: "1rem" }} />
          <Spinner animation="grow" size="sm" />
        </div>
      ) : (
        <div className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }} >
          {plData && (
            <GroupingDrilldownTable grouping={plData}
              selectedL1={selectedL1}
              selectedL2={selectedL2} />
          )}
        </div>
      )
      }
    </>
  );
};

export default PNLStatement;

